import ClipLoader from 'react-spinners/ClipLoader';
import ClockLoader from 'react-spinners/ClockLoader';
import './Loader.css';

interface LoaderProps {
  text?: string;
  variant?: 'clip' | 'clock';
}

const Loader = ({ text = 'Aguarde un instante', variant = 'clip' }: LoaderProps) => {
  return (
    <div className="loaderSpinner">
      <span>{text}</span>
      {variant === 'clip' ? <ClipLoader color="#184b76" /> : <ClockLoader color="#184b76" />}
    </div>
  );
};

export default Loader;
